module.exports = __webpack_public_path__ + "img/suitcase.132a5fc.jpg";